// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Answer from "./answer.js"
import OptionPosition from "./option-position.js"
import Step from "./step.js"

const modelClassData = {
  "attributes": {
    "answers_count": {
      "column": {
        "default": 0,
        "name": "answers_count",
        "null": false,
        "type": "integer"
      },
      "name": "answers_count",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "image_path": {
      "column": null,
      "name": "image_path",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    },
    "score": {
      "column": {
        "default": 0,
        "name": "score",
        "null": true,
        "type": "integer"
      },
      "name": "score",
      "selected_by_default": null,
      "translated": null
    },
    "step_to_go_to_id": {
      "column": {
        "default": null,
        "name": "step_to_go_to_id",
        "null": true,
        "type": "uuid"
      },
      "name": "step_to_go_to_id",
      "selected_by_default": null,
      "translated": null
    },
    "value": {
      "column": {
        "default": null,
        "name": "value",
        "null": true,
        "type": "string"
      },
      "name": "value",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Option",
  "collectionKey": "options",
  "collectionName": "options",
  "i18nKey": "option",
  "camelizedLower": "option",
  "name": "Option",
  "nameDasherized": "option",
  "pluralName": "options",
  "ransackable_associations": [
    {
      "className": "Answer",
      "collectionName": "answers",
      "foreignKey": "option_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "Answer",
      "through": null
    },
    {
      "className": "Element",
      "collectionName": "elements",
      "foreignKey": "element_id",
      "name": "element",
      "macro": "belongs_to",
      "resource_name": "Element",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "image_file_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "image_file_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "image_file_attachment"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "OptionPosition",
      "collectionName": "option_positions",
      "foreignKey": "option_id",
      "name": "option_positions",
      "macro": "has_many",
      "resource_name": "OptionPosition",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_to_go_to_id",
      "name": "step_to_go_to",
      "macro": "belongs_to",
      "resource_name": "Step",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "answers_count",
      "column": {
        "default": 0,
        "name": "answers_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "element_id",
      "column": {
        "default": null,
        "name": "element_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_element_id",
      "column": {
        "default": null,
        "name": "old_element_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_step_to_go_to_id",
      "column": {
        "default": null,
        "name": "old_step_to_go_to_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "score",
      "column": {
        "default": 0,
        "name": "score",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "step_to_go_to_id",
      "column": {
        "default": null,
        "name": "step_to_go_to_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "value",
      "column": {
        "default": null,
        "name": "value",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Answer",
      "collectionName": "answers",
      "foreignKey": "option_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "Answer",
      "through": null
    },
    {
      "className": "OptionPosition",
      "collectionName": "option_positions",
      "foreignKey": "option_id",
      "name": "option_positions",
      "macro": "has_many",
      "resource_name": "OptionPosition",
      "through": null
    },
    {
      "className": "Step",
      "collectionName": "steps",
      "foreignKey": "step_to_go_to_id",
      "name": "step_to_go_to",
      "macro": "belongs_to",
      "resource_name": "Step",
      "through": null
    }
  ],
  "paramKey": "option",
  "primaryKey": "id"
}

/** Frontend model for Option. */
export default class Option extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number} */
  answersCount() {
    return this.readAttributeUnderscore("answers_count")
  }

  /** @returns {boolean} */
  hasAnswersCount() {
    const value = this.answersCount()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  imagePath() {
    return this.readAttributeUnderscore("image_path")
  }

  /** @returns {boolean} */
  hasImagePath() {
    const value = this.imagePath()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  score() {
    return this.readAttributeUnderscore("score")
  }

  /** @returns {boolean} */
  hasScore() {
    const value = this.score()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  stepToGoToId() {
    return this.readAttributeUnderscore("step_to_go_to_id")
  }

  /** @returns {boolean} */
  hasStepToGoToId() {
    const value = this.stepToGoToId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  value() {
    return this.readAttributeUnderscore("value")
  }

  /** @returns {boolean} */
  hasValue() {
    const value = this.value()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./answer.js").default>} */
  answers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["option_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "answers",
        model: this,
        modelClass: Answer
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./answer.js").default>>} */
  loadAnswers() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["option_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "answers",
        model: this,
        modelClass: Answer
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./answer.js").default>>} */
  ensureAnswersLoaded() {
    return this.ensureAssociationLoaded("answers")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./option-position.js").default>} */
  optionPositions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["option_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "option_positions",
        model: this,
        modelClass: OptionPosition
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./option-position.js").default>>} */
  loadOptionPositions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["option_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "option_positions",
        model: this,
        modelClass: OptionPosition
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./option-position.js").default>>} */
  ensureOptionPositionsLoaded() {
    return this.ensureAssociationLoaded("option_positions")
  }

  /** @returns {import("./step.js").default | null} */
  stepToGoTo() {
    return this._readBelongsToReflection({modelClass: Step, reflectionName: "step_to_go_to"})
  }

  /** @returns {Promise<import("./step.js").default | null>} */
  loadStepToGoTo() {
    if (!("stepToGoToId" in this)) throw new Error("Foreign key method wasn't defined: stepToGoToId")

    const id = this.stepToGoToId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "step_to_go_to",
        model: this,
        modelClass: Step
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./step.js").default | null>} */
  ensureStepToGoToLoaded() {
    return this.ensureAssociationLoaded("step_to_go_to")
  }
}
